import { ACTION, PAGE_NAMES, RESOURCES } from 'constant';
import { ACTION_IDS } from '../../../constants';
import { IBankAccountDetails, IBankUpiListParams, IUpiDetails } from '../model/bankUpiDetail.model';

export const makeBankAndUpiActionList = (params: IBankUpiListParams) => {
	const { hasPermissionV2 } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Unset Bank Account',
				id: ACTION_IDS.UNSET_ACCOUNT_NUM,
				isEnabled: (rowData: IBankAccountDetails) => {
					const { isActive, accountNumber } = rowData;
					if (!isActive || !accountNumber) {
						return false;
					}
					return hasPermissionV2({
						configPageName: PAGE_NAMES.userProfile,
						configResourceName: RESOURCES.basicDetails,
						configActionName: ACTION.unsetBankAccount
					});
				}
			},
			{
				name: 'Unset Upi Account',
				id: ACTION_IDS.UNSET_UPI_ID,
				isEnabled: (rowData: IUpiDetails) => {
					const { isActive, upiId } = rowData;
					if (!isActive || !upiId) {
						return false;
					}
					return hasPermissionV2({
						configPageName: PAGE_NAMES.userProfile,
						configResourceName: RESOURCES.basicDetails,
						configActionName: ACTION.unsetUpiId
					});
				}
			}
		]
	};
};

export default {
	makeBankAndUpiActionList
};
